export default __webpack_public_path__ + "static/media/calendar_blue.7f9ac3f0.svg";